<template>

    <vs-prompt :title="modalTitle" :accept-text="$t('MODULES.save')" :cancel-text="$t('MODULES.cancel')" @accept="onModalSubmit" :active.sync="isModalActive">
      <div class="mt-4" v-for="field in data" :key="field.hash">

        <input v-if="field.name === 'hash'" type="hidden" v-model="fieldModel[field.hash]" />

        <template v-else-if="field.mask && field.type_id === 3">
          <label class="vs-input--label">{{ $displayLabel(field, 'title') }}</label>
          <div class="vx-input-group flex mb-0">
            <div class="vx-input-group-default flex-grow">
              <div>
                <div class="vs-component vs-con-input-label vs-input inputx vs-input-primary">
                  <div class="vs-con-input">
                  <the-mask :type="'text'" autocomplete="new-password" :name="field.name" v-model="fieldModel[field.hash]" :mask="['(##) ####-####', '(##) #####-####']" class="vs-inputx vs-input--input normal hasValue need-style-placeholder disabled-field-class" :maxlength="field.length || 524288" style="border: 1px solid rgba(0, 0, 0, 0.2);"/>
                  </div>
                  <span></span>
                </div>
              </div>
            </div>
          </div>
        </template>

        <template v-else-if="field.mask && field.type_id !== 3">
          <label class="vs-input--label">{{ $displayLabel(field, 'title') }}</label>
          <div class="vx-input-group flex mb-0">
            <div class="vx-input-group-default flex-grow">
              <div>
                <div class="vs-component vs-con-input-label vs-input inputx vs-input-primary">
                  <div class="vs-con-input">
                  <the-mask :type="'text'" autocomplete="new-password" :name="field.name" v-model="fieldModel[field.hash]" :mask="field.mask" class="vs-inputx vs-input--input normal hasValue need-style-placeholder disabled-field-class" :maxlength="field.length || 524288" style="border: 1px solid rgba(0, 0, 0, 0.2);"/>
                  </div>
                  <span></span>
                </div>
              </div>
            </div>
          </div>
        </template>

        <template v-else-if="booleanFields.includes(field.type_id)" class="con-s w-full mb-2">
          <label class="vs-input--label">{{ $displayLabel(field, 'title') }}</label>
          <ul>
            <li>
              <vs-switch v-model="fieldModel[field.hash]" class="mt-2" />
            </li>
          </ul>
        </template>

        <template v-else-if="textFields.includes(field.type_id)">
          <vs-input
            style="width: 100%!important;"
            v-if="textFields.includes(field.type_id)"
            :label="$displayLabel(field, 'title')"
            v-model="fieldModel[field.hash]"
          />
        </template>

        <template v-else-if="dateFields.includes(field.type_id)">
          <label class="vs-input--label">{{ $displayLabel(field, 'title') }}</label>
          <div :data-field-hash="field.hash" type="from">
            <vx-input-group>
              <template slot="prepend">
                <div class="prepend-text bg-primary" style="height: 37px!important;">
                  <span :is="'calendar-icon'" size="1x"></span>
                </div>
              </template>

              <datepicker class="mb-3" data-is-date="true" v-model="fieldModel[field.hash]" style="width: 100%!important;display: inline-block;" placeholder="" :language="languages['ptBR']" format="dd/MM/yyyy"></datepicker>
            </vx-input-group>
          </div>
        </template>

        <template v-else-if="datetimeFields.includes(field.type_id)">
          <label class="vs-input--label">{{ $displayLabel(field, 'title') }}</label>
          <div>
            <vx-input-group>
              <template slot="prepend">
                <div class="prepend-text bg-primary" style="height: 37px!important;">
                  <span :is="'calendar-icon'" size="1x"></span>
                </div>
              </template>

              <flat-pickr v-model="fieldModel[field.hash]" :config="{ enableTime: true, dateFormat: 'd/m/Y H:i:S', enableSeconds: true, time_24hr: true }" placeholder="" class="w-full" :name="'datetime-from'+field.hash" />
            </vx-input-group>
          </div>
        </template>

        <template v-else-if="listFields.includes(field.type_id)">
          <label class="vs-input--label">{{ $displayLabel(field, 'title') }}</label>
          <v-select v-model="fieldModel[field.hash]" :options="optionFieldModel[field.hash]" label="label">
            <template v-slot:option="option">
              <span>{{ $displayLabel(option, 'label') }}</span>
            </template>
            <template v-slot:selected-option="option">
              <span>{{ option ? $displayLabel(option, 'label') : '' }}</span>
            </template>
          </v-select>
        </template>

      </div>
    </vs-prompt>


</template>

<script>
import StringMask from 'string-mask'
import vSelect from 'vue-select';
import Datepicker from 'vuejs-datepicker';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import * as lang from 'vuejs-datepicker/src/locale';
import { CalendarIcon } from 'vue-feather-icons'

export default {
  components: {
    vSelect,
    Datepicker,
    flatPickr,
    CalendarIcon
  },
  props: {
    isActive: Boolean,
    data: Array,
    modalTitle: String,
    onSubmit: Function,
    fieldHash: String,
    currentFormData: Object
  },
  computed: {
    isModalActive: {
      get() {
        return this.isActive
      },
      set(value) {
        this.$emit('isModalActive', value)
      }
    }
  },
  data() {
    return {
      disabledDatesModel: {},
      disabledDatetimesModel: {},
      datesModel: {},
      datetimesModel: {},
      languages: lang,
      textFields: [1, 3, 4, 5, 6, 7, 8, 9, 10, 11, 14, 15, 19],
      booleanFields: [23],
      numberFields: [2],
      moneyFields: [16, 18],
      dateFields: [12],
      datetimeFields: [13],
      listFields: [24, 25, 29, 30],

      secretFields: {},
      peopleSelected:[],
      dependentFieldOptions: {},
      dependentFieldDisableStatus: {},
      childFields: {},
      people: [],
      showEmptyDataMessage: false,
      show: {},
      fieldModel: {},
      optionFieldModel: {},
      blocks: [],
      blocksOriginal: [],
      detail: {},
      permissions: {},
      enableEdit: {},
      decimalFields: {},
      currencyFields: {},
      mandatoryFields: [],
      minValueMaxValueFields: {},
      relatedFieldsObject: {},
      fieldType: {},
      fieldTitle: {},
      fieldName: {},
      hoverImageList: {},
      showFieldsModel: {},
      callApiFields: {},
      normalFields: [1, 3, 4, 5, 6, 7, 8, 9, 10, 11, 14, 15],
      specialFields: [2, 12, 13, 16, 17, 18, 19, 20, 21, 22, 23],
      textFields: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 14, 15, 16, 17, 18, 19, 20],
      floatFields: [16, 18, 20],
      objectFields: [24, 25, 29, 30],
      uploadFields: [21, 22, 27, 28],
      dateFields: [12],
      dateTimeFields: [13],
      booleanFields: [23],
      refFields: [2, 3, 16, 17, 18, 20, 12, 13],
      keyPicklistItems: {},
      refFieldsFireStatus: {}
    }
  },
  methods: {
    onModalSubmit() {
      this.onSubmit(this.fieldModel, this.fieldHash)
    },
    buildModalForm() {
      for(const fieldItem of this.data) {
        this.setFieldsModels(fieldItem)
      }
    },
    setFieldsModels(fieldItem, rebuild = false) {
      if(fieldItem.secret) {
        this.$set(this.secretFields, fieldItem.hash, {
          visible: false,
        })
      }

      if (fieldItem.mandatory) {
        this.mandatoryFields.push(fieldItem.hash)
      }

      if(fieldItem.call_api) {

        // if(this.refFields.includes(fieldItem.type_id) || fieldItem.mask) {
        setTimeout(() => {
          this.$set(this.refFieldsFireStatus, fieldItem.hash, false)

          try {
            this.$refs[`ref-${fieldItem.hash}`][0].$el.addEventListener('focusout', (event) => {
              this.callFieldApi(this.fieldModel[fieldItem.hash], fieldItem.type_id, fieldItem.hash, fieldItem.minimal_timeout)
            })
          } catch(e) {
            this.$refs[`ref-${fieldItem.hash}`][0].addEventListener('focusout', (event) => {
              this.callFieldApi(this.fieldModel[fieldItem.hash], fieldItem.type_id, fieldItem.hash, fieldItem.minimal_timeout)
            })
          }


        }, 600)
        // }
      }

      if(!rebuild) {
        if(fieldItem.type_id === 2) {

          try {
            parseInt(fieldItem.min_value)
            parseInt(fieldItem.max_value)

            if((fieldItem.min_value !== null && fieldItem.max_value !== null) || (fieldItem.min_value !== undefined && fieldItem.max_value !== undefined)) {
              this.$set(this.minValueMaxValueFields, fieldItem.hash, {
                minValue: parseInt(fieldItem.min_value),
                maxValue: parseInt(fieldItem.max_value)
              })
            }
          } catch(e) {
            //
          }
        } else if(fieldItem.type_id === 12) {

          if((fieldItem.min_value !== null && fieldItem.max_value !== null)) {

            let minDay = parseInt(fieldItem.min_value.split('-')[2])
            let minMonth = parseInt(fieldItem.min_value.split('-')[1]) - 1
            let minYear = parseInt(fieldItem.min_value.split('-')[0])

            const minDate = new Date(minYear, minMonth, minDay)

            let maxDay = parseInt(fieldItem.max_value.split('-')[2])
            let maxMonth = parseInt(fieldItem.max_value.split('-')[1]) - 1
            let maxYear = parseInt(fieldItem.max_value.split('-')[0])

            const maxDate = new Date(maxYear, maxMonth, maxDay)

            this.$set(this.minValueMaxValueFields, fieldItem.hash, {
              minValue: minDate,
              maxValue: maxDate
            })
          } else {
            this.$set(this.minValueMaxValueFields, fieldItem.hash, {
              minValue: null,
              maxValue: null
            })
          }
        } else if(fieldItem.type_id === 13) {
          if((fieldItem.min_value !== null && fieldItem.max_value !== null)) {

            let minDay = parseInt(fieldItem.min_value.split(' ')[0].trim().split('-')[2])
            let minMonth = parseInt(fieldItem.min_value.split(' ')[0].trim().split('-')[1]) - 1
            let minYear = parseInt(fieldItem.min_value.split(' ')[0].trim().split('-')[0])
            let minHour = parseInt(fieldItem.min_value.split(' ')[1].trim().split(':')[0])
            let minMinute = parseInt(fieldItem.min_value.split(' ')[1].trim().split(':')[1])
            let minSecond = parseInt(fieldItem.min_value.split(' ')[1].trim().split(':')[2])

            const minDate = new Date(minYear, minMonth, minDay, minHour, minMinute, minSecond)

            let maxDay = parseInt(fieldItem.max_value.split('-')[2])
            let maxMonth = parseInt(fieldItem.max_value.split('-')[1]) - 1
            let maxYear = parseInt(fieldItem.max_value.split('-')[0])
            let maxHour = parseInt(fieldItem.max_value.split(' ')[1].trim().split(':')[0])
            let maxMinute = parseInt(fieldItem.max_value.split(' ')[1].trim().split(':')[1])
            let maxSecond = parseInt(fieldItem.max_value.split(' ')[1].trim().split(':')[2])

            const maxDate = new Date(maxYear, maxMonth, maxDay, maxHour, maxMinute, maxSecond)

            this.$set(this.minValueMaxValueFields, fieldItem.hash, {
              minValue: minDate,
              maxValue: maxDate
            })
          } else {
            this.$set(this.minValueMaxValueFields, fieldItem.hash, {
              minValue: null,
              maxValue: null
            })
          }
        } else if (fieldItem.type_id === 16) {

          this.$set(this.decimalFields, fieldItem.hash, {
            decimal: ',',
            thousands: '.',
            prefix: '',
            suffix: '',
            precision: fieldItem.decimals,
            masked: false
          })

          if (fieldItem.payload === '' || fieldItem.payload === null) {
            fieldItem.payload = 0
          } else {
            fieldItem.payload = parseFloat(fieldItem.payload)
          }
          this.$set(this.fieldModel, fieldItem.hash, fieldItem.payload)
        } else if (fieldItem.type_id === 18) {
          this.$set(this.currencyFields, fieldItem.hash, {
            decimal: ',',
            thousands: '.',
            prefix: '',
            suffix: '',
            precision: fieldItem.decimals || 2,
            masked: false
          })

          if (fieldItem.payload === '' || fieldItem.payload === null) {
            fieldItem.payload = 0
          } else {
            fieldItem.payload = parseFloat(fieldItem.payload)
          }
        } else if (fieldItem.type_id === 20) {

          this.$set(this.decimalFields, fieldItem.hash, {
            decimal: ',',
            thousands: '.',
            prefix: '',
            suffix: '',
            precision: fieldItem.decimals,
            masked: false
          })

          if (fieldItem.payload === '' || fieldItem.payload === null) {
            fieldItem.payload = 0
          } else {
            fieldItem.payload = parseFloat(fieldItem.payload)
          }
          this.$set(this.fieldModel, fieldItem.hash, fieldItem.payload)
        } else if (fieldItem.type_id === 21) {
          this.$set(this.hoverImageList, fieldItem.hash, true)
        } else if (fieldItem.type_id === 22) {
          this.$set(this.show, fieldItem.hash, false)
        } else if (fieldItem.type_id === 24 && fieldItem.name === 'assigned_to_id') {

          this.$set(this.fieldModel, fieldItem.hash, {})
          const optionsList = []
          fieldItem.options.forEach((optionFieldItem) => {

            optionsList.push({ value: optionFieldItem.value, label: optionFieldItem.label, group: optionFieldItem.group, groupLevel: optionFieldItem.groupLevel, assignTypeId: optionFieldItem.assignTypeId, selected: optionFieldItem.selected })

            if (optionFieldItem.selected) {
              this.fieldModel[fieldItem.hash] = { value: optionFieldItem.value, label: optionFieldItem.label, group: optionFieldItem.group, groupLevel: optionFieldItem.groupLevel, assignTypeId: optionFieldItem.assignTypeId, selected: optionFieldItem.selected }
            }
          })

          this.$set(this.optionFieldModel, fieldItem.hash, optionsList)
        } else if (fieldItem.type_id === 24 && fieldItem.name !== 'assigned_to_id') {

          this.$set(this.keyPicklistItems, fieldItem.hash, {})

          this.$set(this.fieldModel, fieldItem.hash, {})
          const optionsList = []
          fieldItem.options.forEach((optionFieldItem) => {

            optionsList.push({ value: optionFieldItem.value, label: optionFieldItem.label, selected: optionFieldItem.selected })

            if ((optionFieldItem.selected) || (fieldItem.default_value === optionFieldItem.label)) {
              setTimeout(() => {
                this.fieldModel[fieldItem.hash] = { value: optionFieldItem.value, label: optionFieldItem.label, selected: true }

                this.onPicklistFieldChange({ value: optionFieldItem.value, label: optionFieldItem.label, selected: true }, fieldItem.hash)

              }, 300)
            }

            this.$set(this.keyPicklistItems[fieldItem.hash], optionFieldItem.value, optionFieldItem.selected ? true : false)
            // this.$computed(`field_${fieldItem.hash}`, () => {
            //   return this.fieldModel[fieldItem.hash]
            // })

            // this.$watch(`field_${fieldItem.hash}`, (value) => {
            //   console.log(value)
            // })
          })

          const findSelected = optionsList.findIndex((item) => item.selected === true)

          if(findSelected === -1) {
            optionsList.unshift({value: 0, label: 'Selecione uma opção...', selected: true})
            this.fieldModel[fieldItem.hash] = {value: 0, label: 'Selecione uma opção...', selected: true}
          }

          this.$set(this.optionFieldModel, fieldItem.hash, optionsList)
        } else if(fieldItem.type_id === 25 || fieldItem.type_id === 30) {

          this.$set(this.relatedFieldsObject, fieldItem.related_module_hash, fieldItem.hash)

          this.$set(this.fieldModel, fieldItem.hash, {})
          const optionsList = []
          if(Array.isArray(fieldItem.options)) {
            fieldItem.options.forEach((optionFieldItem) => {
              optionsList.push({ value: optionFieldItem.value, label: optionFieldItem.label })
            })

            this.$set(this.optionFieldModel, fieldItem.hash, optionsList)
            if(Array.isArray(fieldItem.field_children)) {
              this.$set(this.childFields, fieldItem.hash, fieldItem.field_children)
            }
            this.$set(this.optionFieldModel, fieldItem.hash, optionsList)

            this.$set(this.dependentFieldDisableStatus, fieldItem.hash, false)

            this.$set(this.showFieldsModel, fieldItem.hash, true)

          } else {
            //dependentFieldOptions
            this.$set(this.optionFieldModel, fieldItem.hash, [])

            this.$set(this.dependentFieldOptions, fieldItem.hash, fieldItem.options)

            this.$set(this.dependentFieldDisableStatus, fieldItem.hash, true)

            this.$set(this.showFieldsModel, fieldItem.hash, true)

          }
        } else if(fieldItem.type_id === 27) {
          this.fieldModel[fieldItem.hash] = { lat: -23.501103, lng: -46.8504457 }
        } else if (fieldItem.type_id === 29) {
          this.$set(this.fieldModel, fieldItem.hash, {})
          const optionsList = []
          fieldItem.options.forEach((optionFieldItem) => {

            optionsList.push({ value: optionFieldItem.value, label: optionFieldItem.label, color: optionFieldItem.color })

          })

          this.fieldModel[fieldItem.hash] = {}

          const defaultObject = optionsList.find(x => x.label === fieldItem.default_value)

          this.fieldModel[fieldItem.hash] = defaultObject

          this.$set(this.optionFieldModel, fieldItem.hash, optionsList)
        } else if (fieldItem.type_id !== 24 && fieldItem.type_id !== 29 && fieldItem.type_id !== 31) {

          if (fieldItem.name === 'active') {
            this.$set(this.fieldModel, fieldItem.hash, true)
          } else {
            this.$set(this.fieldModel, fieldItem.hash, fieldItem.default_value)
          }
        } else if(fieldItem.type_id === 31) {
          this.$set(this.moduleItemsModel, fieldItem.hash, [])
          this.$set(this.selectedRows, fieldItem.hash, [])

          const moduleItemsTitles = []

          for(const $fieldItem of fieldItem.payload) {
            moduleItemsTitles.push({name: $fieldItem.name, title: $fieldItem.title})
          }


          this.$set(this.moduleItemsTitlesModel, fieldItem.hash, moduleItemsTitles)
          this.$set(this.moduleItemsFields, fieldItem.hash, fieldItem.payload)


        }

        if(JSON.stringify(this.currentFormData) !== '{}') {
          if(fieldItem.hash in this.currentFormData) {
            this.fieldModel[fieldItem.hash] = this.currentFormData[fieldItem.hash]
          }
        }



        this.$set(this.fieldTitle, fieldItem.hash, fieldItem.title)
        this.$set(this.fieldName, fieldItem.hash, fieldItem.name)
        this.$set(this.fieldType, fieldItem.hash, fieldItem.type_id)
      }
    },
  },
  watch: {
    'isModalActive'(value) {
      if(value) {
        this.buildModalForm()
      }
    }
  }
}
</script>

<style>

</style>
